import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = {
  id: "features",
  class: "scroll-mt-20"
}
const _hoisted_3 = {
  id: "partners",
  class: "scroll-mt-20"
}

import { defineComponent } from 'vue'
import HeroSection from '@/components/HeroSection.vue'
import Features from '@/components/FeatureSection.vue'
import PartnersSection from '@/components/PartnersSection.vue'
// import Testimonials from '@/components/TestimonialSection.vue'
// import Pricing from '@/components/PricingSection.vue'

// Ensure components are registered

export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

defineComponent({
  components: {
    HeroSection,
    Features,
    PartnersSection,
    // Testimonials,
    // Pricing
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeroSection),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(Features)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(PartnersSection)
    ])
  ]))
}
}

})